import React, { useMemo } from "react";
import { Field } from "react-final-form";

import AddressGeolocateInput from "../../inputs/AddressGeolocateInput";
import RffInputWrapper from "../shared/RffInputWrapper";

const RffAddressInputField = React.memo(function RffAddressInputField({
  name,
  label,
  required,
  placeholder = "Enter your address",
  suppressGrid,
  size,
  helperText,
  disabled,
  onBlur,
  testing,
  sx,
  hideButtons = true,
  keepInputVisible = true,
}) {
  // Only re-create this validate function when "required" changes
  const validate = useMemo(() => {
    if (required) {
      // Custom validator for address object
      return (value) => {
        if (!value || !value.fullAddress) {
          return "Required";
        }
        return undefined;
      };
    }
    return undefined;
  }, [required]);

  return (
    <RffInputWrapper
      label={label}
      suppressGrid={suppressGrid}
      size={size}
      required={required}
      testing={testing}
    >
      <Field
        name={name}
        validate={validate}
        // Subscribe to the needed bits of Field state
        subscription={{
          value: true,
          error: true,
          touched: true,
          initial: true,
        }}
        render={({ input, meta }) => {
          // Create a wrapped onChange handler that works with the address object
          const handleChange = (addressObject) => {
            // Call React Final Form's onChange with the address object
            input.onChange(addressObject);

            // Call custom onBlur if provided when value changes
            if (onBlur && addressObject !== input.value) {
              onBlur({
                field: name,
                newValue: addressObject,
                oldValue: input.value,
              });
            }
          };

          // Use either the current value or the initial value if available
          const addressValue = input.value || meta.initial || null;

          return (
            <AddressGeolocateInput
              value={addressValue}
              onChange={handleChange}
              placeholder={placeholder}
              error={meta.touched && !!meta.error}
              helperText={(meta.touched && meta.error) || helperText}
              sx={sx}
              disabled={disabled}
              hideButtons={hideButtons}
              keepInputVisible={keepInputVisible}
              fullWidth
            />
          );
        }}
      />
    </RffInputWrapper>
  );
});

export default RffAddressInputField;
